import script from "./breadcrumb.vue?vue&type=script&setup=true&lang=js"
export * from "./breadcrumb.vue?vue&type=script&setup=true&lang=js"

import "./breadcrumb.vue?vue&type=style&index=0&id=53a321ea&lang=scss"

const __exports__ = script;

export default __exports__